(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["subscription-banner-v2"] && !Shopify.designMode) return;
  try {
    
  const setSubscription = () => {
    const link = "/products/copper-slim-bundle-sub"
    const container = document.querySelector(".subscription_section")
    const elementToGo = container?.querySelector('.subscription_section__content')
    const label = container?.querySelector("label[for='subMode']")
    const topSpace = 55
    
    if (label) {
      label.click()

      if (elementToGo) {
        const elementToGoPosition = elementToGo.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({
          top: elementToGoPosition - topSpace,
          behavior: 'smooth'
        });
      }
    } else {
      window.location.href = link
    }
  }

  window.setSubscription = setSubscription;

  document.addEventListener("DOMContentLoaded", function() {
    new Swiper(".sub-banner__items", {
      freeMode: false,
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 20
        },
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      mousewheel: {
        forceToAxis: true,
      },
      scrollbar: {
        el: ".sub-banner__items .swiper-scrollbar",
        freeMode: true,
        draggable: true,
        hide: false
      },
      spaceBetween: 6,
      slidesPerView: 2.2,
      watchOverflow: true,
      centerInsufficientSlides: true,
    });
  });

  } catch(e) { console.error(e); }
})();
})();
